import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class ForbiddenResponseInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly snack: MatSnackBar,
  ) {}

  private isForbiddenBody(body: unknown): boolean {
    if (!body || typeof body !== 'object') {
      return false;
    }

    const responseBody = body as { code?: string | number; status?: string };
    const codeValue = String(responseBody.code || '').trim();
    const statusValue = String(responseBody.status || '')
      .trim()
      .toLowerCase();

    return codeValue === '403' && statusValue === 'forbidden';
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && this.isForbiddenBody(event.body)) {
          const body: any = event.body;
          const serverMessage =
            typeof body.message === 'string' ? body.message : '';
          this.router.navigate(['/forbidden-403'], {
            state: {
              message:
                serverMessage ||
                'You do not have permission to access this resource.',
            },
            skipLocationChange: true,
            replaceUrl: true,
          });
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // if (this.isForbiddenBody(error.error)) {
        //   const body: any = error.error || {};
        //   const serverMessage = typeof body.message === 'string' ? body.message : '';
        //   this.router.navigate(['/forbidden-403'], {
        //     state: { message: serverMessage || 'You do not have permission to access this website.' },
        //     skipLocationChange: true,
        //     replaceUrl: true,
        //   });
        // }
        if (this.isForbiddenBody(error.error)) {
          this.snack.open(error.error.message, 'Close', {
            duration: 5000,
          });
        }
        return throwError(() => error);
      }),
    );
  }
}
